import React, { useEffect, useRef, useState } from 'react';

const GeneratedImage = ({
  imageUrl,
  width,
  height,
}: {
  imageUrl: string | undefined;
  width: number | undefined;
  height: number | undefined;
}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (imageRef.current) {
      const img = imageRef.current;
      const bounds = img.parentElement?.getBoundingClientRect();

      const handleImageLoad = () => {
        if (!bounds) return;

        const maxDimension = Math.max(img.naturalWidth, img.naturalHeight);
        const scale = Math.min(
          bounds.width / maxDimension,
          bounds.height / maxDimension,
        );

        setDimensions({
          width: img.naturalWidth * scale,
          height: img.naturalHeight * scale,
        });
      };

      img.addEventListener('load', handleImageLoad);

      if (img.complete) {
        handleImageLoad();
      }

      return () => {
        img.removeEventListener('load', handleImageLoad);
      };
    }
  }, [imageRef, imageUrl]);

  useEffect(() => {
    console.log('dimensions:', dimensions);
  }, [dimensions]);

  if (!imageUrl || !width || !height) return null;

  return (
    <img
      ref={imageRef}
      src={imageUrl}
      width={dimensions.width}
      height={dimensions.height}
    />
  );
};

export default GeneratedImage;
